import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Btn from "../../shared/button/Btn"
import InputCityTown from "../../shared/input/new/InputCityTown"
import InputText from "../../shared/input/new/InputText"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { updateRoadRoute } from "../../../features/admin3/admin3Slice"
import locationData from "../../../utils/locationData/locationOptions"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 600px;
        height: 600px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        overflow-x: hidden;
        position: relative;
        .content{
            margin-block: 20px;
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            .input-containers{
                display: flex;
                flex-direction: column;
                .top-inputs{
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    border-bottom: 2px solid;
                    border-color: ${({ theme }) => theme.mainBorderColor};
                    padding-bottom: 20px;
                }
                .route-list{
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    p{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                        text-decoration: underline;
                    }
                    .route-item{
                        width: 100%;
                        border-bottom: 1px solid;
                        border-color: ${({ theme }) => theme.mainBorderColor};
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        padding-block: 20px;
                    }
                    .route-item:last-child{
                        border-bottom: none;
                    }
                }
            }
        }

        .error{
            color: var(--color-main);
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            padding-block: 10px;
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            padding-block: 10px;
            gap: 10px;
            border-top: 2px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            position: sticky;
            bottom: 0;
            z-index: 99;
            background-color: ${({ theme }) => theme.mainBgColor};
        }
    }
`


const UpdateRoadRouteModal = () => {

    const dispatch = useDispatch()
    const {selectedInspectionStationRoute} = useSelector((state) => state.admin3)

    const location = useLocation()
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [startPoint, setStartPoint] = useState(locationData?.find((item) => item?.location === selectedInspectionStationRoute?.startPoint.replace(/\s/g, '')))
    const [endPoint, setEndPoint] = useState(locationData?.find((item) => item?.location === selectedInspectionStationRoute?.endPoint.replace(/\s/g, '')))
    const [routeName, setRouteName] = useState(selectedInspectionStationRoute?.name)
    
    const [routeList, setRouteList] = useState(selectedInspectionStationRoute?.roadRouteLocations?.$values)
    

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    
    const handleSubmit = () => {
        
    
        const addData = {
            id: selectedInspectionStationRoute.id,
            name: routeName,
            startPoint: startPoint?.location,
            endPoint: endPoint?.location,
            inspectionStationLocationId: selectedInspectionStationRoute.inspectionStationLocationId,
            roadRouteLocations: routeList
        };
    
        dispatch(updateRoadRoute(addData));
    };
    

    const handleChange = (id, field, value) => {
        setRouteList((prevRouteList) =>
            prevRouteList.map((item) =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Rota Ekle"}/>
            <div className="content">
               <div className="input-containers">
                    <div className="top-inputs">
                        <InputText data={routeName} setData={(e)=>setRouteName(e.target.value)} inputWidth={"100%"} labelText="Rota Adı" name={"routeName"} />
                        <InputCityTown data={startPoint?.location} setData={setStartPoint} inputWidth={"100%"} labelText="Başlangıç" name={"startPoint"}/>
                        <InputCityTown data={endPoint?.location} setData={setEndPoint} inputWidth={"100%"} labelText="Bitiş" name={"endPoint"}/>
                    </div>

                    <div className="route-list">
                        {routeList.map((item) => (
                            <div className="route-item">
                                <p>{item.type}. Konum</p>
                                <InputText data={item.latitude}  setData={(e) => handleChange(item.id, "latitude", e.target.value)} inputWidth={"100%"} labelText="Lat" name={"latitude"} />
                                <InputText data={item.longitude}  setData={(e) => handleChange(item.id, "longitude", e.target.value)} inputWidth={"100%"} labelText="Lng" name={"longitude"} />
                                <InputText data={item.radius} setData={(e) => handleChange(item.id, "radius", e.target.value)} inputWidth={"100%"} labelText="Çap" name={"radius"} />
                                <InputText data={item.distanceToStation} setData={(e) => handleChange(item.id, "distanceToStation", e.target.value)} inputWidth={"100%"} labelText="İstasyona Mesafe" name={"distanceToStation"} />
                                {item.id !== 1 && <InputText data={item.message} setData={(e) => handleChange(item.id, "message", e.target.value)} inputWidth={"100%"} labelText="Mesaj" name={"message"} />}
                            </div>
                        ))}
                    </div>
               </div>
               <div className='button-grp'>
                    <Btn color={"#E85446"} bgColor={"transparent"} width="100px" radius={"10px"} handleClick={handleSubmit}>Güncelle</Btn>
                    <Btn color={"#E85446"} bgColor={"transparent"} width="100px" radius={"10px"} handleClick={()=> dispatch(showModal(null))}>Kapat</Btn>
                </div>
            </div>
            
        </div>
    </ModalContainer>
  )
}

export default UpdateRoadRouteModal